// client/src/pages/Home.tsx

import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/pages.css";

const Home: React.FC = () => {
  return (
    <div className="page home-page">
      <h2>Welcome to LavernAI</h2>
      <p>You are about to explore the best CBC experience in Kenya. Use the navigation below to explore the app.</p>
      <nav>
        <ul>
          <li>
            <Link to="/auth">Auth</Link>
          </li>
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li>
            <Link to="/learninghub">Learning Hub</Link>
          </li>
          <li>
            <Link to="/assessment">Assessment</Link>
          </li>
          <li>
            <Link to="/analytics">Analytics</Link>
          </li>
          <li>
            <Link to="/settings">Settings</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Home;
